const countryCode = {
  THA: 'THA'
}

export default countryCode
